import axios from '@axios'

const PREFIX = '/enquadramentos'

export default {

  getEnquadramentosResumidos(filtro) {
    return axios.post(`${PREFIX}/resumido`, filtro)
  },
}
